import { GET_PAST_VITALS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface PastVitals {
    status: string;
    data: Data;
}

export type Item = VitalHistory & { id: string };

export interface IPastVitals {
    name: string;
    column: DataColumn[];
    values: Vital[];
    id: string;
    pid?: string;
    unit?: string;
}

export interface VitalHistory {
    name: string;
    column: DataColumn[];
    values: Vital[];
}

export interface DataColumn {
    key: string;
    val: string;
}

export type PastVitalsData = { [k: string]: VitalHistory };

export interface Data {
    vitalData: PastVitalsData;
    patientProfileData: PatientProfileData;
}
export interface ColumnEntity {
    key: string;
    val: string;
}
export interface Value {
    aUnit: string;
}
export interface Interp {
    v: string;
    c: string;
}

export interface ValuesEntity1 {
    dt: string;
    tm: string;
    vl: string;
    value: Value1;
    actor: 'Patient' | 'Practitioner';
    isoDateObject: string;
    interp?: Interp;
    range?: Range;
    vital_id: string;
    document_id?: string;
    result?: string;
}

export interface Range {
    low?: number;
    high?: number;
    display_text?: string;
}

export interface Value1 {
    aValue: number;
    aUnit: string;
}
export interface PatientProfileData {
    mn: string;
    ln: string;
    'dob-valid': boolean;
    fn: string;
    oid: string;
    pic: string;
    email: string;
    gen: string;
    'is-p': boolean;
    as: string;
    mobile?: string;
    dob: string;
    uuid: string;
    bloodgroup: string;
    'is-d': boolean;
    type: number;
}

export type Vital = ValuesEntity1 & {
    [k: string]: string;
};

export default (pid: string): Promise<PastVitals> =>
    fetchWithRefresh(GET_PAST_VITALS(pid)).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw new Error('failed');
        }
    });
